import React from 'react';
import { Accordion, Box, Heading, Paragraph } from '@zillow/constellation-10';
import { FAQ_CONTENT } from '../../../constants/tenant-screening-services';

export function FAQSection() {
  return (
    <Box
      css={{
        paddingTop: { base: '0', lg: '0' },
        paddingLeft: { base: 'xs', lg: '0' },
        paddingRight: { base: 'xs', lg: '0' },
        paddingBottom: { base: '0', lg: '80px' },
        maxWidth: '816px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Accordion.Root>
        {FAQ_CONTENT.map((faq, index) => (
          <Accordion.Item key={index} value={index.toString()}>
            <Accordion.Header>
              <Heading level={4} textStyle="body-lg-bold">
                {faq.question}
              </Heading>
            </Accordion.Header>
            <Accordion.Panel>
              <Paragraph>{faq.answer}</Paragraph>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </Box>
  );
}
